import { useEffect, useMemo, useState } from 'react'
import { Tab } from '@headlessui/react'
import classNames from '@components/utils/classNames'
import FilterList from './FilterList'
import {
  GENERAL_CLOSE,
  GENERAL_FILTER_TITLE,
  GENERAL_SORT_FILTER_TITLE,
  PRODUCT_FILTER,
} from '@components/utils/textVariables'
import { useUI } from '@components/ui'
import { API_STATUS, EmptyGuid } from '@components/utils/constants'
import { GA_EVENT } from 'hooks/ga_event.modal'
import { recordGA4Event } from '@components/services/analytics/ga4'
import {
  Cross,
  DownArrowFilled,
  FiltersCloseIcon,
  Slider,
} from '@components/icons'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode } from 'swiper'
import { useRouter } from 'next/router'
import { MEN_COLLECTIONS_ACTION_TYPES } from '@components/men/helpers/reducer'
import { getCurrentPage } from '@framework/utils/app-util'

interface Props {
  products: any
  handleSortBy: any
  handleFilters: any
  routerFilters: any
  clearAll: any
  routerSortOption: any
  handleFiltersApply: any
  swrLoading: any
  setFiltersLoader?: (val: API_STATUS) => void
  deviceInfo?: any
  hideSortFilter?: boolean
}

export interface ISortItem {
  key: string
  name: string
  eventValue: string
  item: string
}

export default function CollectionMobileFilters({
  products = { filters: [] },
  handleSortBy,
  routerFilters,
  clearAll,
  routerSortOption,
  handleFiltersApply,
  deviceInfo,
  handleFilters,
  setFiltersLoader,
  hideSortFilter = false,
}: Props) {
  const [active, setActive] = useState(false)
  const [selectFilters, setSelectFilters] = useState<any>([])
  const [sortOption, setSortOption] = useState<any>(routerSortOption)
  const [activeTab, setActiveTab] = useState<number>(0)
  const [activeTabName, setActiveTabName] = useState<string>('Sort')
  const [localFilters, setLocalFilters] = useState<Array<any>>([])
  const { user } = useUI()
  const { isOnlyMobile } = deviceInfo
  const router = useRouter()

  let filters = useMemo(
    () => new Array(...(products?.filters ?? [])),
    [JSON.stringify(products?.filters)]
  )

  const sortItems: ISortItem[] = [
    {
      key: '',
      name: 'Relevance',
      item: 'Sort',
      eventValue: 'sort:relevance',
    },
    {
      key: '1',
      name: 'Price : Low to High',
      item: 'Sort',
      eventValue: 'sort:price_low_to_high',
    },
    {
      key: '2',
      name: 'Price : High to Low',
      item: 'Sort',
      eventValue: 'sort:price_high_to_low',
    },
    {
      key: '6',
      name: 'Discount',
      item: 'Sort',
      eventValue: 'sort:discount',
    },
  ]

  useEffect(() => {
    setSelectFilters([...routerFilters])
  }, [routerFilters, active])

  useEffect(() => {
    setLocalFilters([])
  }, [router?.query?.collection?.[0]])

  useEffect(() => {
    if (routerSortOption !== '') {
      setSortOption(routerSortOption)
    } else {
      setSortOption('')
    }
  }, [router?.query?.collection?.[0], active])

  useEffect(() => {
    let element = document.getElementById('product-sticky-bar')
    if (active && element) {
      element.style.zIndex = '1'
    }

    return () => {
      if (element) {
        element.style.zIndex = '49'
      }
    }
  }, [active])

  useEffect(() => {
    if (isOnlyMobile) {
      if (localFilters?.length === 0 && products?.filters?.length > 0) {
        // comment code return empty array in filter swiper
        // if (
        //   localFilters?.filter((item: { name: string }) => item.name === 'Sort')
        //     .length === 0
        // ) {
        //   return
        // } else
        if (hideSortFilter) {
          setLocalFilters(filters)
          return
        } else {
          let sortItem = {
            name: 'Sort',
            items: sortItems,
          }
          filters.unshift(sortItem)
          setLocalFilters(filters)
        }
      }
    }
  }, [
    products?.filters,
    products?.sortList,
    filters,
    isOnlyMobile,
    // sortItems,
    localFilters,
  ])

  const handleSelectFilters = (filter: any, type: any) => {
    if (filter.item == 'Sort') {
      return
    }
    if (type === MEN_COLLECTIONS_ACTION_TYPES.REMOVE_FILTERS)
      setSelectFilters(
        selectFilters.filter((o: any) => o.Value !== filter.Value)
      )
    else setSelectFilters([...selectFilters, filter])
  }

  const handleSort = (filter: any, type: any) => {
    if (type === MEN_COLLECTIONS_ACTION_TYPES.REMOVE_FILTERS) {
      setSortOption(null)
    } else {
      setSortOption(filter)
    }
  }

  const handleCloseFilter = (isApplyReset?: boolean) => {
    handleClick(isApplyReset)
    removeClassHtml()
    setSelectFilters([])
  }

  const getHeaderForFilterClickGAEvent = (_activeTab: string) => {
    if (_activeTab === undefined || _activeTab === 'Sort') {
      setActiveTabName('filter/sort')
      return 'filter/sort'
    } else if (_activeTab === 'Filter Colour') {
      setActiveTabName('Colour')
      return 'Colour'
    } else {
      setActiveTabName(_activeTab)
      return _activeTab
    }
  }

  const handleClick = (isApplyReset?: boolean, _activeTab?: string) => {
    setActive(!active)
    if (_activeTab) {
      const _index = localFilters?.findIndex(
        (item: any) => item?.name === _activeTab
      )
      setActiveTab(_index)
    }

    if (!active) {
      recordGA4Event(window, GA_EVENT.FILTER_CLICK, {
        current_page: getCurrentPage(),
        header: getHeaderForFilterClickGAEvent(_activeTab || ''),
        filter_value: '',
        loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
      })
    }
    const element: any = document.getElementsByTagName('html')[0]
    const elementheader: any = document.getElementById('header-mob')
    elementheader.classList.add('z-index-overlay')
    element.classList.add('overlow-y-mob-fixed')
  }

  const removeClassHtml = () => {
    const element: any = document.getElementsByTagName('html')[0]
    element.classList.remove('overlow-y-mob-fixed')
    const elementheader: any = document.getElementById('header-mob')
    elementheader.classList.remove('z-index-overlay')
    let barElement = document.getElementById('product-sticky-bar')
    if (barElement) {
      element.style.zIndex = '49'
    }
  }

  const outerFiltersList = localFilters?.filter(
    (item: any) =>
      item?.name?.toLowerCase() !== 'sort' &&
      item?.name?.toLowerCase() !== 'category'
  )

  const appliedFilters = localFilters?.reduce(
    (acc: any, obj: any) => {
      acc.forEach((item: any) => {
        if (item.Key === obj.key) {
          item['name'] = obj.name
          return item
        }
        return acc
      })
      return acc
    },
    [...routerFilters]
  )

  const removeAppliedFilter = (rm: any) => {
    handleFilters(rm, MEN_COLLECTIONS_ACTION_TYPES.REMOVE_FILTERS)
  }

  const handleActiveTabName = (_index: number) => {
    const activeTabObj = localFilters?.find(
      (item: any, index: number) => index === _index
    )
    if (activeTabObj?.name === 'Filter Colour') {
      setActiveTabName('Colour')
    } else {
      setActiveTabName(activeTabObj?.name)
    }
  }

  const getSortCount = () => {
    if (routerSortOption !== '') {
      return 1
    } else {
      return 0
    }
  }

  const appliedFiltersCount = appliedFilters?.length + getSortCount()

  return (
    <div className="bg-transparent sort-filter" style={{ width: '100%' }}>
      <div
        className={`${
          active ? 'navbar-mobile' : 'hidden'
        }  flex flex-wrap w-full nav-overlay sm:hidden`}
        onClick={() => {
          handleCloseFilter()
        }}
      />
      <nav
        className={`${
          active ? 'navbar-mobile' : 'hidden'
        }  flex flex-wrap w-full nav-bg sm:hidden`}
      >
        <div
          className={`${
            active ? 'animate-filter-popup' : 'hidden'
          }   w-full lg:inline-flex lg:flex-grow lg:w-auto bg-white fixed bottom-0 left-0 right-0`}
        >
          <div className="flex flex-col items-start w-full lg:inline-flex lg:flex-row lg:ml-auto lg:w-auto lg:items-center lg:h-auto">
            <div className="flex items-center justify-between px-4 pt-4">
              <h2 className="text-lg font-bold text-primary">
                {GENERAL_SORT_FILTER_TITLE}
              </h2>
              <button
                type="button"
                className="absolute flex items-end justify-end w-10 h-6 p-2 mt-3 -mr-2 text-gray-400 bg-white rounded-md sm:h-10 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 right-4"
                onClick={() => {
                  handleCloseFilter()
                }}
              >
                <span className="sr-only">{GENERAL_CLOSE}</span>
                <Cross className="w-6 h-6 text-black" aria-hidden="true" />
              </button>
            </div>

            <form className="grid w-full grid-cols-12 mt-2 border-t border-gray-200">
              <Tab.Group
                vertical
                selectedIndex={activeTab}
                onChange={(index: number) => {
                  handleActiveTabName(index)
                  setActiveTab(index)
                }}
              >
                <Tab.List className="col-span-3 border-r border-gray-200 max-panel-mobile-filter">
                  {localFilters?.map(
                    (section: any, sid: number) =>
                      section.key != 'brandNoAnlz' &&
                      section.name != 'Colour' &&
                      section?.items?.length > 0 &&
                      section.name != 'Price' && (
                        <Tab
                          key={sid}
                          className={({ selected }) =>
                            classNames(
                              'w-full py-2.5 text-14 font-medium leading-5 dark:text-black text-blue-700 text-left pl-4',
                              'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 dark:text-black focus:outline-none focus:ring-2',
                              selected
                                ? 'bg-white after:content-[""] after:text-red-500 dark:text-black after:right-0 after:w-2 after:h-2 after:bg-orange-500 after:inline-block after:rounded-full after:ml-1 after:relative after:-top-2 border-r-2 border-black'
                                : 'text-blue-100 hover:bg-white/[0.12] hover:text-white dark:text-black'
                            )
                          }
                        >
                          {section.name == 'Filter Colour' ||
                          section.name == 'Filtercolour'
                            ? 'Colour'
                            : section.name}
                        </Tab>
                      )
                  )}
                </Tab.List>
                <Tab.Panels className="col-span-9">
                  {localFilters?.map(
                    (section: any, sid: number) =>
                      section.key != 'brandNoAnlz' &&
                      section.name != 'Colour' &&
                      section?.items?.length > 0 &&
                      section.name != 'Price' && (
                        <Tab.Panel
                          className={classNames(
                            'rounded-xl bg-white p-0',
                            'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2 h-full'
                          )}
                          key={sid}
                        >
                          <div className="h-full space-y-0 sm:space-y-6">
                            <FilterList
                              handleFilters={handleSelectFilters}
                              handleSort={handleSort}
                              sectionKey={section.key}
                              sectionName={section?.name}
                              items={section.items}
                              routerFilters={selectFilters}
                              routerSort={sortOption}
                              closeSidebar={() => {}}
                              removeClassHtml={() => {}}
                            />
                          </div>
                        </Tab.Panel>
                      )
                  )}
                </Tab.Panels>
              </Tab.Group>
            </form>
          </div>
          <div className="sticky bottom-0 left-0 right-0 z-20 w-full p-3 bg-white border-t border-gray-200">
            <div className="grid-cols-12 sm:grid-cols-12">
              <button
                onClick={(e: any) => {
                  // setFiltersLoader && setFiltersLoader(API_STATUS.LOADING)
                  clearAll()
                  handleCloseFilter(true)
                  setSortOption('')
                }}
                type="button"
                // disabled={!routerFilters.length && !sortOption}
                disabled={
                  routerSortOption === '' && appliedFilters?.length === 0
                }
                className="w-2/5 col-span-8 px-8 py-3 text-primary border border-gray-300 disabled:opacity-50"
              >
                Reset
              </button>
              <button
                disabled={
                  !routerFilters.length &&
                  !selectFilters.length &&
                  sortOption === null
                }
                onClick={() => {
                  // setFiltersLoader && setFiltersLoader(API_STATUS.LOADING)
                  const sortItem = sortItems.find(
                    (datum) => datum.key === sortOption
                  )
                  handleFiltersApply(selectFilters, sortItem, activeTabName)
                  handleSortBy(sortOption)
                  handleCloseFilter(true)
                }}
                type="button"
                className="w-3/5 col-span-4 px-8 py-3 text-white bg-black border border-gray-300 disabled:opacity-50"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </nav>
      {/* Mobile filter dialog */}
      {/* <div className="px-0 text-center sm:px-6 lg:max-w-7xl lg:px-8"> */}
      <div className="px-0 text-center sm:px-6 w-full lg:px-8">
        <section aria-labelledby="filter-heading" className="py-0">
          <h2 id="filter-heading" className="sr-only">
            {PRODUCT_FILTER}
          </h2>

          <div className="flex items-center justify-between">
            <h2 id="filter-heading" className="sr-only">
              {GENERAL_FILTER_TITLE}
            </h2>
            <Swiper
              slidesPerView={'auto'}
              spaceBetween={6}
              navigation={false}
              loop={false}
              freeMode={true}
              modules={[FreeMode]}
              slidesOffsetBefore={16}
              // style={{
              //   marginLeft: '0.375rem',
              // }}
              className={`sm:border-t-0 mySwiper icon-bg-none category-filter-swiper`}
              style={hideSortFilter ? { paddingLeft: '12px' } : {}}
            >
              {/* hide sort filter swiper on bases of flag */}
              {!hideSortFilter ? (
                <SwiperSlide className="w-auto">
                  <div
                    className="relative col-start-1 row-start-1 py-2 rounded-lg sm:py-3 lg:border-0 lg:mt-0 lg:mb-0"
                    style={{
                      border: '1px solid #E9E5DF',
                    }}
                  >
                    <div className="flex px-3 mx-auto space-x-6 text-xs divide-x divide-gray-200 max-w-7xl sm:px-6 lg:px-8">
                      <div>
                        <button
                          onClick={() => {
                            setActiveTab(0)
                            handleActiveTabName(0)
                            handleClick(undefined, 'Sort')
                          }}
                          className="flex items-center font-normal text-black group w-max"
                        >
                          {appliedFiltersCount > 0 ? (
                            <span
                              className="w-5 h-5 bg-orange text-white text-10 mr-1 flex justify-center items-center"
                              style={{ borderRadius: '50%' }}
                            >
                              {appliedFiltersCount}
                            </span>
                          ) : null}
                          <span className="text-xs">Filter / Sort</span>
                          <Slider
                            className="flex-none ml-1 text-black rotate-0 group-hover:text-gray-500"
                            aria-hidden="true"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ) : (
                <></>
              )}

              {appliedFilters.map((appliedFilter: any, idx: number) => {
                if (appliedFilter.Key === 'rating')
                  return (
                    <SwiperSlide key={idx} className="w-auto">
                      <span
                        onClick={() => {
                          // setFiltersLoader &&
                          //   setFiltersLoader(API_STATUS.LOADING)
                          removeAppliedFilter(appliedFilter)
                        }}
                        style={{
                          paddingTop: '10px',
                          paddingBottom: '10px',
                        }}
                        className="flex justify-center items-center gap-x-2 relative rounded-lg inline-block px-5 text-xs font-normal text-black border bg-selected-facet"
                      >
                        {parseFloat(appliedFilter.Value).toFixed(1)} ★{' '}
                        <button
                          type="button"
                          className="flex justify-center items-center"
                        >
                          <FiltersCloseIcon />
                        </button>
                      </span>
                    </SwiperSlide>
                  )
                return (
                  <SwiperSlide key={idx} className="w-auto">
                    <div
                      key={`applied-filter-${idx}`}
                      className="flex text-xs text-left text-gray-600 items-left w-auto"
                    >
                      {appliedFilter.name ? (
                        <>
                          <span
                            onClick={() => {
                              // setFiltersLoader &&
                              //   setFiltersLoader(API_STATUS.LOADING)
                              removeAppliedFilter(appliedFilter)
                            }}
                            style={{
                              paddingTop: '10px',
                              paddingBottom: '10px',
                            }}
                            className="flex justify-center items-center gap-x-2 relative rounded-lg inline-block px-5 text-xs font-normal text-black border bg-selected-facet"
                          >
                            {appliedFilter.Value}{' '}
                            <button
                              type="button"
                              className="flex justify-center items-center"
                            >
                              <FiltersCloseIcon />
                            </button>
                          </span>
                        </>
                      ) : null}
                    </div>
                  </SwiperSlide>
                )
              })}
              {outerFiltersList?.map((item: any, index: number) => (
                <SwiperSlide
                  className={`px-0 w-auto`}
                  key={index}
                  style={{ width: 'auto' }}
                >
                  <div
                    className="relative col-start-1 row-start-1 py-2.5 rounded-lg sm:py-3 lg:border-0 lg:mt-0 lg:mb-0 w-auto"
                    style={{
                      border: '1px solid #E9E5DF',
                    }}
                    key={index}
                  >
                    <div className="flex px-3 mx-auto space-x-6 text-xs divide-x divide-gray-200 max-w-7xl sm:px-6 lg:px-8">
                      <button
                        onClick={() => {
                          handleClick(undefined, item?.name)
                        }}
                        className="flex items-center font-normal text-xs text-black group w-max"
                        key={index}
                      >
                        <span>
                          {item?.name === 'Filter Colour' ||
                          item?.name === 'Filtercolour'
                            ? 'Colour'
                            : item?.name}
                        </span>
                        <DownArrowFilled className="ml-2" />
                      </button>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>
      </div>
    </div>
  )
}
function action(key: any): void {
  throw new Error('Function not implemented.')
}
